/**
 * 统一日期时间格式化工具
 * 格式: YYYY-MM-DD HH:MM (如 2026-05-11 14:30)
 */

function pad2(n: number): string {
  return n < 10 ? `0${n}` : String(n);
}

/**
 * 格式化日期时间 - 列表页标准格式
 * 输出: YYYY-MM-DD HH:MM
 */
export function formatDateTime(dateInput: string | Date | null | undefined): string {
  if (!dateInput) return "-";
  try {
    const d = typeof dateInput === "string" ? new Date(dateInput) : dateInput;
    if (isNaN(d.getTime())) return "-";
    const year = d.getFullYear();
    const month = pad2(d.getMonth() + 1);
    const day = pad2(d.getDate());
    const hour = pad2(d.getHours());
    const minute = pad2(d.getMinutes());
    return `${year}-${month}-${day} ${hour}:${minute}`;
  } catch {
    return "-";
  }
}

/**
 * 格式化日期 - 仅年月日
 * 输出: YYYY-MM-DD
 */
export function formatDate(dateInput: string | Date | null | undefined): string {
  if (!dateInput) return "-";
  try {
    const d = typeof dateInput === "string" ? new Date(dateInput) : dateInput;
    if (isNaN(d.getTime())) return "-";
    const year = d.getFullYear();
    const month = pad2(d.getMonth() + 1);
    const day = pad2(d.getDate());
    return `${year}-${month}-${day}`;
  } catch {
    return "-";
  }
}

/**
 * 格式化日期时间 - 完整格式（含秒）
 * 用于详情页展示
 * 输出: YYYY-MM-DD HH:MM:SS
 */
export function formatDateTimeFull(dateInput: string | Date | null | undefined): string {
  if (!dateInput) return "-";
  try {
    const d = typeof dateInput === "string" ? new Date(dateInput) : dateInput;
    if (isNaN(d.getTime())) return "-";
    const year = d.getFullYear();
    const month = pad2(d.getMonth() + 1);
    const day = pad2(d.getDate());
    const hour = pad2(d.getHours());
    const minute = pad2(d.getMinutes());
    const second = pad2(d.getSeconds());
    return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
  } catch {
    return "-";
  }
}